export default "__VITE_ASSET__429bc09b__"